export const addSignalRConnection = (hubName, connection) => ({
    type: 'ADD_SIGNALR_CONNECTION',
    payload: { hubName, connection }
});

export const removeSignalRConnection = (hubName, isReconnecting) => ({
    type: 'REMOVE_SIGNALR_CONNECTION',
    payload: { hubName, isReconnecting }
});

export const clearAllSignalRConnections = () => ({
    type: 'CLEAR_ALL_CONNECTIONS'
});

export const isReconnected = (hubName, value) => ({
    type: 'IS_RECONNECTED_HUB',
    payload: { hubName, value }
});